/**
 * Route and Role Constants
 * Centralized constants for routes and user roles to avoid hardcoding values
 */
import { PERMISSIONS } from "../security/permissions";
export { PERMISSIONS };
export const GROUPS = {
  SUPERADMIN: "Superadmin",
  ADMINS: "Admins",
  PROJECT_MANAGERS: "Project Managers",
  FINANCE_OFFICERS: "Finance Officers",
  STAFF: "Staff",
};

export const ROLES = {
  ADMIN: "admin",
  PROJECT_MANAGER: "project_manager",
  FINANCE_OFFICER: "finance_officer",
  STAFF: "staff",
};

export const USR_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  PENDING: "pending",
};

export const PRJ_STATUS = {
  ACTIVE: "active",
  ON_HOLD: "on_hold",
  COMPLETED: "completed",
  IN_PROGRESS: "in_progress",
  INACTIVE: "inactive",
  ARCHIVED: "archived",
  PLANNED: "planned",
};

export const OUTS_CONSTANTS = {
  CODE: "code",
  TITLE: "title",
  DESCRIPTION: "description",
  OWNER: "owner",
  STATUS: "status",
  RAG: "rag",
  RISK: "risk",
  ASSUMPTIONS: "assumptions",
  LINKED_ITEMS: "linked_items",
  COMPLETION_NOTE: "completion_note",
  RAG_COMMENT: "rag_comment",
  START: "start_date",
  END: "end_date",
  ID: "id",
  SOV: "sov",
};

export const OUTS_STATUS = {
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
  PLANNED: "planned",
  ON_HOLD: "on_hold",
};


export const RAG_STATUS = {
  RED: "R",
  AMBER: "A",
  GREEN: "G",
};

//  Role groups (collections of GROUPS)
export const ROLE_GROUPS = {
  // Only admins
  ADMINS: [GROUPS.ADMINS],

  // All staff (base role)
  STAFF: [GROUPS.STAFF],

  // Staff and above (staff, PMs, finance, admins)
  STAFF_AND_ABOVE: [
    GROUPS.STAFF,
    GROUPS.PROJECT_MANAGERS,
    GROUPS.FINANCE_OFFICERS,
    GROUPS.ADMINS,
  ],
  PROJECT_MANAGERS: [GROUPS.PROJECT_MANAGERS],
  FINANCE_OFFICERS: [GROUPS.FINANCE_OFFICERS],

  // Managers and above (PMs, finance, admins)
  MANAGERS_AND_ABOVE: [
    GROUPS.PROJECT_MANAGERS,
    GROUPS.FINANCE_OFFICERS,
    GROUPS.ADMINS,
  ],

  // Authenticated users (any logged-in role)
  AUTHENTICATED: [
    GROUPS.STAFF,
    GROUPS.PROJECT_MANAGERS,
    GROUPS.FINANCE_OFFICERS,
    GROUPS.ADMINS,
  ],
};

// Route constants
export const ROUTES = {
  LOGIN: "/login",
  UNAUTHORIZED: "/unauthorized",
  NOT_FOUND: "/404",

  SET_PASSWORD: "/password/set",
  FORGOT_PASSWORD: "/password/forgot",
  RESET_PASSWORD_CONFIRM: "/password/reset/confirm",

  DASHBOARD: "/dashboard",
  PROFILE: "/profile",

  ADMIN: "/admin",
  ADMIN_USERS: "/admin/users",
  ADMIN_SETTINGS: "/admin/settings",
  ADMIN_AUDIT: "/admin/audit",

  USERS: "/users",
  USER_DETAIL: "/users/:id",
  USER_CREATE: "/users/create",
  USER_EDIT: "/users/:id/edit",

  PROJECTS: "/projects",
  PROJECT_DETAIL: "/projects/:id",
  PROJECT_CREATE: "/projects/create",
  PROJECT_EDIT: "/projects/:id/edit",

  OUTPUTS: "/outputs",
  OUTCOMES: "/outcomes",

  BUDGETS: "/budgets",
  EXPENSES: "/expenses",

  INDICATORS: "/indicators",
  REPORTING: "/reporting",
};
export const ROUTE_ACCESS = {
  [ROUTES.DASHBOARD]: { requiresAuth: true },
  [ROUTES.PROFILE]: { requiresAuth: true },

  // Admin section (group-based)
  [ROUTES.ADMIN]: { groups: [GROUPS.ADMINS] },
  [ROUTES.ADMIN_USERS]: { groups: [GROUPS.ADMINS] },
  [ROUTES.ADMIN_SETTINGS]: { groups: [GROUPS.ADMINS] },
  [ROUTES.ADMIN_AUDIT]: { groups: [GROUPS.ADMINS] },

  // User management
  [ROUTES.USERS]: { groups: [GROUPS.ADMINS] },
  [ROUTES.USER_DETAIL]: { requiresAuth: true }, // own profile visible
  [ROUTES.USER_CREATE]: { groups: [GROUPS.ADMINS] },
  [ROUTES.USER_EDIT]: { groups: [GROUPS.ADMINS] },
};

export const DRAWER_WIDTH = 240;

export const ROLE_DISPLAY = {
  [ROLE_GROUPS.ADMINS]: { label: "Admin", showCheck: true },
  [ROLE_GROUPS.STAFF]: { label: "Staff", showCheck: false },

  [ROLE_GROUPS.PROJECT_MANAGERS]: {
    label: "Project Manager",
    showCheck: false,
  },
  [ROLE_GROUPS.FINANCE_OFFICERS]: {
    label: "Finance Officer",
    showCheck: false,
  },
};

export const charLimits = {
  LEARNING: 2000,
  RAG_COMMENT: 2000,
  FILE_NAME: 200,
};

export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB in bytes
export const ALLOWED_EXTENSIONS = [
  "pdf",
  "doc",
  "docx",
  "xlsx",
  "csv",
  "png",
  "jpg",
  "jpeg",
];
export const MAX_FILES = 5;
